export var IPageStatus;
(function (IPageStatus) {
    IPageStatus["LOADING"] = "loading";
    IPageStatus["SUCCESS"] = "success";
    IPageStatus["ERROR"] = "error";
    IPageStatus["IDLE"] = "idle";
})(IPageStatus || (IPageStatus = {}));
